// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{ showShippingFormErrors: boolean }>;

export const DispatchSetShowShippingFormErrors: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/CheckoutReviewAndSubmit/SetShowShippingFormErrors",
        showShippingFormErrors: props.parameter.showShippingFormErrors,
    });
};

export const chain = [DispatchSetShowShippingFormErrors];

const setShowShippingFormErrors = createHandlerChainRunner(chain, "SetShowShippingFormErrors");
export default setShowShippingFormErrors;
